intra_module.controller('UserProfileCtrl', function($scope, $sce, identity, user, hub_web_url) {
    $scope.me     = identity;
    $scope.user   = user;

    $scope.params = {
        target:    'users',
        entity_id: user.id
    };
	
	$scope.isMyWall = () => (($scope.me !== null) && ($scope.user !== null) && ($scope.me.login == $scope.user.login));
	$scope.iAmADM = () => (($scope.me !== null) && $scope.me.groups.includes('adm'));
	$scope.notStudent = () => !(($scope.me === null) || $scope.me.groups.includes('student'));

	const url = `${hub_web_url}/intra/registration/student_alert_box`;
	// without this, the ng-src will never accept our url...
	$scope.turbo_frame_src = $sce.trustAsResourceUrl(url);
	
});
